<template>
  <div
    class="chartjs-tooltip py-2"
    :style="style"
  >
    <div class="tooltip-title text-xs-center px-3">
      <span class="date">
        {{ date.split(' ').join('') }}
      </span>
      <span class="ml-1">
        {{ isPast ? 'の配送実績' : 'の配送予定' }}
      </span>
    </div>

    <div class="tooltip-header mt-1">
      <div
        v-for="item in dataset.slice(0, 2)"
        :key="item.id"
        :style="item.style"
        class="item px-3"
      >
        <span class="value">
          {{ item.value }}
        </span>
        <span class="suffix ml-1">
          {{ item.suffix }}
        </span>
      </div>
    </div>

    <div
      v-if="!isPast"
      class="tooltip-detail mt-2"
    >
      <template
        v-for="item in dataset.slice(2, 4)"
        class="item"
      >
        <component
          :is="svgLine(item.id)"
          :key="'line' + item.id"
          color="#777"
          join
          class="line"
        />
        <span
          :key="'text' + item.id"
          class="text pl-1 pr-2"
        >
          {{ item.text }}
        </span>
        <span
          :key="'value' + item.id"
          class="value"
        >
          {{ item.value }}
        </span>
        <span
          :key="'suffix' + item.id"
          class="suffix pl-1 pr-3"
        >
          {{ item.suffix }}
        </span>
      </template>
    </div>

    <div
      v-else
      class="pb-1"
    />

    <div
      v-if="leftOver"
      class="left-warning pl-2 pr-1 pt-3 pb-1 mt-3 mx-auto"
    >
      猶予切れで選択されていない顧客：<span class="num">{{ leftOver }}件</span>
    </div>
  </div>
</template>

<script>
import { childLine, childLineEnd } from '@/svgs'

const members = new Map([
  ['件数', 1],
  ['給油量', 2],
  ['日付指定', 3],
  ['猶予切れ', 4],
  ['今日中残', 5]
])

export default {
  name: 'ChartTooltip',
  components: {
    childLine,
    childLineEnd
  },
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  computed: {
    isPast () {
      return this.model.body.length <= 3
    },
    leftOver () {
      return this.dataset.find(el => el.id === 5)?.value
    },
    dataset () {
      return this.model.body.reduce((acc, el, i) => {
        const [text, value] = getActualValue(el)
        if (value === 'NaN') return acc
        const id = members.get(text)
        const suffix = id === 2
          ? 'ℓ'
          : '件'
        return [ ...acc,
          {
            id,
            text,
            value,
            suffix,
            style: this.model.labelColors[i]
          }
        ]
      }, [])
        .sort((a, b) => a.id - b.id)
    },
    style () {
      return {
        left: this.model.x + 'px',
        top: this.model.y + 'px',
        transform: `translate(${this.translateX}, ${this.translateY})`
      }
    },
    translateX () {
      switch (this.model.xAlign) {
        case 'left':
          return '30%'
        case 'right':
          return '-30%'
        default:
          return 0
      }
    },
    translateY () {
      switch (this.model.yAlign) {
        case 'top':
          return '20%'
        case 'bottom':
          return '-30%'
        case 'center':
          return '-10%'
        default:
          return 0
      }
    },
    date () {
      return this.model.title
        ? this.model.title[0]
        : ''
    }
  },
  methods: {
    svgLine (id) {
      return id === 3
        ? childLine
        : childLineEnd
    }
  }
}
// helpers
const getActualValue = obj => obj.lines[0].split(':').map(el => el.trim())
</script>

<style lang="scss" scoped>
.chartjs-tooltip {
  position: absolute;
  display: flex;
  flex-direction: column;
  pointer-events: none;
  border: 1px solid #000;
  background: rgba(255, 255, 255, .9);
  border-radius: 20px;
  transition: transform .5s ease;

  .tooltip-title {
    font-family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif";
    font-size: 0.8rem;
    display: flex;
    justify-content: center;
    align-items: center;

    .date {
      font-family: monospace;
      font-weight: bold;
      font-size: 0.9rem;
    }
  }

  .tooltip-header {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    width: 100%;
    font-size: 0.8rem;
      border-top: 1px solid #000;
      border-bottom: 1px solid #000;

    .item {
      display: flex;
      align-items: center;
      justify-content: center;
      .value {
        font-size: 1rem;
        font-weight: bold;
      }
    }
  }

  .tooltip-detail {
    display: grid;
    grid-template-columns: 30px 1fr max-content max-content;
    align-items: center;
    justify-items: end;
    font-size: 0.8rem;
    line-height: 1.3;

    .line {
        height: 100%;
    }

    .text {
      justify-self: center;
    }

    .value {
      font-weight: bold;
      font-size: 1rem;
      justify-self: center;
    }
  }

  .left-warning {
    color: red;
    width: 140px;
    white-space: wrap;
    font-size: 0.8rem;
    font-weight: bold;
    border-top: 1px solid red;
    text-align: center;
    line-height: 1.1;

    .num {
      font-size: 1.1rem;
      text-decoration: underline;
    }
  }
}
</style>
